import { FC } from 'react';
import { TextField as MuiTextField, BaseTextFieldProps } from '@mui/material';
import { useField } from 'formik';

interface TextFieldProps extends BaseTextFieldProps {
  name: string;
  startAdornment?: React.ReactNode;
}

export const TextField: FC<TextFieldProps> = ({ name, startAdornment, ...props }) => {
  const [field, meta] = useField(name);

  const config = {
    fullWidth: true,
    size: 'small' as 'small',
    ...field,
    ...props
  };

  if (meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }

  if (startAdornment) {
    return (
      <MuiTextField
        {...config}
        variant="outlined"
        InputProps={{
          startAdornment
        }}
      />
    );
  }

  return <MuiTextField {...config} variant="outlined" />;
};
